module.exports = __webpack_public_path__ + "static/media/Instagram.37c28126.svg";